/**
 * @file 领取收益弹窗主要内容
 */
import { RewardQuery } from '@/types/claim';
import { Row } from '@/components';
import { useFm } from '@web3/base-hooks';
import cls from 'classnames';
import { formatUSDYield } from '@/utils/num';

import styles from './index.module.scss';

interface Props {
  rewardList: RewardQuery[];
  rewardValue: number;
  className?: string;
}

export const ClaimContent = (props: Props) => {
  const { rewardList, rewardValue, className } = props;

  const fm = useFm();
  return (
    <div className={cls(styles.container, className)}>
      {rewardList.map((item) => {
        return (
          <div className={styles.row} key={item.contractAddress}>
            <div className={styles.left}>
              <img className={styles.coinIcon} src={item.iconUrl} />
              <div>{item.symbol}</div>
            </div>
            <div>
              <div className={styles.amount}>{item.amount}</div>
              <div className={styles.value}>
                {formatUSDYield(`${+item.amount * +item.usdPrice}`)}
              </div>
            </div>
          </div>
        );
      })}
      <Row
        label={fm('the_cumulative_revenue_is')}
        valueClassName={styles.totalAmountValue}
        value={formatUSDYield(`${rewardValue}`)}
      />
    </div>
  );
};
